import React from 'react';
import './LoadingSpinner.css';

const LoadingSpinner = ({ 
  size = 'md', 
  variant = 'primary', 
  title = 'Loading...', 
  subtitle = '', 
  minHeight = '200px',
  className = '',
  transparent = true 
}) => {
  const getLogoSize = () => {
    switch (size) {
      case 'sm':
        return '40px';
      case 'md':
        return '60px';
      case 'lg':
        return '80px';
      case 'xl':
        return '100px';
      default:
        return '60px';
    }
  };

  const getContainerClass = () => {
    let baseClass = 'loading-spinner-container';
    if (size === 'xl') {
      baseClass += ' loading-spinner-xl';
    }
    if (transparent) {
      baseClass += ' loading-spinner-transparent';
    }
    if (className) {
      baseClass += ` ${className}`;
    }
    return baseClass;
  };

      return (
      <div 
        className={getContainerClass()} 
        style={{ minHeight }}
      >
        <div className="text-center">
          <div className="loading-logo-container">
            <img 
              src="/logo_kg1.jpg" 
              alt="Loading" 
              className="loading-logo"
              style={{ width: getLogoSize(), height: getLogoSize() }}
            />
          </div>
          {title && (
            <div className={`loading-title loading-title-${size}`}>
              {title}
              <span className="loading-dots">
                <span className="dot1">.</span>
                <span className="dot2">.</span>
                <span className="dot3">.</span>
              </span>
            </div>
          )}
          {subtitle && (
            <div className={`loading-subtitle loading-subtitle-${size}`}>
              {subtitle}
            </div>
          )}
        </div>
      </div>
    );
};

export default LoadingSpinner; 